import { createContext, useContext } from 'react'

type FormEditableContextType = {
  isEditable: boolean
}

const defaultContextValue: FormEditableContextType = {
  isEditable: true,
}

export const FormEditableContext =
  createContext<FormEditableContextType>(defaultContextValue)

export const useFormEditable = () => useContext(FormEditableContext)
